/**
 * Módulo: Newsletter
 * Validação front-end do formulário de newsletter.
 */

export function initNewsletter() {
  const forms = document.querySelectorAll('.newsletter__form');

  if (!forms.length) return;

  forms.forEach(form => {
    const fields = {
      nome: form.querySelector('[name="nome"]'),
      sobrenome: form.querySelector('[name="sobrenome"]'),
      email: form.querySelector('[name="email"]'),
      whatsapp: form.querySelector('[name="whatsapp"]'),
      perfil: form.querySelector('[name="perfil"]'),
    };

    // Máscara de telefone
    if (fields.whatsapp) {
      fields.whatsapp.addEventListener('input', (e) => {
        let value = e.target.value.replace(/\D/g, '');

        if (value.length > 11) value = value.slice(0, 11);

        if (value.length > 6) {
          value = `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`;
        } else if (value.length > 2) {
          value = `(${value.slice(0, 2)}) ${value.slice(2)}`;
        } else if (value.length > 0) {
          value = `(${value}`;
        }

        e.target.value = value;
      });
    }

    // Validação ao sair do campo
    Object.entries(fields).forEach(([name, input]) => {
      if (!input) return;

      input.addEventListener('blur', () => {
        validateField(name, input);
      });

      // Remove erro ao digitar
      input.addEventListener('input', () => {
        clearError(name, input);
      });
    });

    // Submit
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      let isValid = true;

      Object.entries(fields).forEach(([name, input]) => {
        if (!input) return;
        if (!validateField(name, input)) {
          isValid = false;
        }
      });

      if (isValid) {
        // Coleta dados sanitizados
        const formData = {
          nome: sanitize(fields.nome.value),
          sobrenome: sanitize(fields.sobrenome.value),
          email: sanitize(fields.email.value),
          whatsapp: fields.whatsapp.value.replace(/\D/g, ''),
          perfil: fields.perfil.value,
        };

        // TODO: Enviar para backend (AJAX/fetch)
        console.log('[Newsletter] Dados validados:', formData);

        // Feedback visual
        const btn = form.querySelector('.newsletter__btn');
        if (btn) {
          btn.textContent = 'Enviado!';
          btn.disabled = true;
          setTimeout(() => {
            btn.textContent = 'Assinar newsletter';
            btn.disabled = false;
            form.reset();
          }, 3000);
        }
      }
    });
  });

  /**
   * Valida um campo individual
   */
  function validateField(name, input) {
    const value = input.value.trim();
    let errorMsg = '';

    switch (name) {
      case 'nome':
        if (!value) errorMsg = 'Informe seu nome.';
        else if (value.length < 2) errorMsg = 'Nome deve ter pelo menos 2 caracteres.';
        break;

      case 'sobrenome':
        if (!value) errorMsg = 'Informe seu sobrenome.';
        else if (value.length < 2) errorMsg = 'Sobrenome deve ter pelo menos 2 caracteres.';
        break;

      case 'email':
        if (!value) errorMsg = 'Informe seu email.';
        else if (!isValidEmail(value)) errorMsg = 'Informe um email válido.';
        break;

      case 'whatsapp':
        const digits = value.replace(/\D/g, '');
        if (!digits) errorMsg = 'Informe seu WhatsApp.';
        else if (digits.length < 10 || digits.length > 11) errorMsg = 'Informe um número válido com DDD.';
        break;

      case 'perfil':
        if (!value) errorMsg = 'Selecione um perfil.';
        break;
    }

    if (errorMsg) {
      showError(name, input, errorMsg);
      return false;
    }

    clearError(name, input);
    return true;
  }

  function showError(name, input, msg) {
    input.classList.add('is-invalid');
    const errorEl = input.closest('.newsletter__field').querySelector(`[data-error="${name}"]`);
    if (errorEl) {
      errorEl.textContent = msg;
      errorEl.classList.add('is-visible');
    }
  }

  function clearError(name, input) {
    input.classList.remove('is-invalid');
    const errorEl = input.closest('.newsletter__field').querySelector(`[data-error="${name}"]`);
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function sanitize(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML.trim();
  }
}
